export default class AssetDevice {
    id;
    name;
    serialNumber;
    note;
    createdAt;
    returnedAt;
    department;
    acceptanceStatus;
    photo;
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => AssetDevice.define(et));
        }
        else if (data != null) {
            return AssetDevice.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let assetDevice = new AssetDevice();
        assetDevice.id = data.Id;
        assetDevice.name = data.Name;
        assetDevice.serialNumber = data.SerialNumber;
        assetDevice.note = data.Note;
        assetDevice.createdAt = data.CreatedAt;
        assetDevice.returnedAt = data.ReturnedAt;
        assetDevice.department = data.Department;
        assetDevice.acceptanceStatus = data.AcceptanceStatus;
        assetDevice.photo = data.Photo;
        return assetDevice;
    }
}
export class Asset {
    id;
    name;
    serialNumber;
    createdAt;
    returnedAt;
    photo;
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => Asset.define(et));
        }
        else if (data != null) {
            return Asset.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let asset = new Asset();
        asset.id = data.Id;
        asset.name = data.Name;
        asset.serialNumber = data.SerialNumber;
        asset.createdAt = data.CreatedAt;
        asset.returnedAt = data.ReturnedAt;
        asset.photo = data.Photo;
        return asset;
    }
}
